import { useQuery } from '@tanstack/react-query'
import { Company, CompaniesSearchRequest } from 'models'
import { currentQueryService } from 'utils/api/queries'

type UseGetCompaniesOptions = {
  enabled?: boolean
}

const useGetCompanies = (request?: CompaniesSearchRequest, options?: UseGetCompaniesOptions) => {
  const effectiveRequest = request ?? {}

  return useQuery<Array<Company>, Error>({
    queryKey: ['useSearchCompanies', request ?? {}],
    queryFn: async () => {
      const response = await currentQueryService.searchCompanies(effectiveRequest)
      return response.items
    },
    enabled: options?.enabled ?? true,
  })
}

export type { UseGetCompaniesOptions }
export { useGetCompanies }
